module.exports = __webpack_public_path__ + "static/media/card.beb6f73d.svg";